var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinexPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FCFBCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7143 11C22.136 11 20.8571 12.2789 20.8571 13.8571V15.5714H14V22.4286H15.5513C17.0462 22.4286 18.4061 23.5042 18.5558 24.9911C18.7272 26.7019 17.3897 28.1429 15.7143 28.1429H14V35H20.8571V33.4487C20.8571 31.9538 21.9328 30.5939 23.4196 30.4442C25.1305 30.2728 26.5714 31.6103 26.5714 33.2857V35H33.4286V28.1429H35.1429C36.7211 28.1429 38 26.864 38 25.2857C38 23.7074 36.7211 22.4286 35.1429 22.4286H33.4286V15.5714H26.5714V13.8571C26.5714 12.2789 25.2926 11 23.7143 11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinexPuzzle);
export default __webpack_public_path__ + "static/media/coinex-puzzle.f7c0d8e089c71515f2b4550206ce24e3.svg";
export { ForwardRef as ReactComponent };